import { PlaylistApiResponse, Album, BuyLink, Track } from "../api/playlist";

export type BuyLinkInfo = {
  vendor: string;
  format: string;
  url: string;
};

export type TrackInfo = {
  id: string;
  name: string;
  artist: string;
  durationMs: number;
  albumId: string;
};

export type PriceData = {
  amount: number;
  source: string; // "discogs" or "estimated"
} | null;

export type AlbumRecommendation = {
  id: string;
  name: string;
  artist: string;
  url: string;
  coverUrl: string;
  releaseYear: number | null;
  trackCount: number;
  tracks: string[]; // Track names for display
  trackDetails: TrackInfo[]; // Full track info for modal
  prices: {
    cd: PriceData;
    vinyl: PriceData;
  };
  buyLinks: BuyLinkInfo[];
};

export type PlaylistRecommendationResult = {
  playlistId: string;
  playlistName: string;
  trackCount: number;
  albumCount: number;
  currency: string;
  totals: {
    cd: number;
    vinyl: number;
  };
  albums: AlbumRecommendation[];
};

export const toPlaylistRecommendation = ({
  data
}: {
  data: PlaylistApiResponse;
}): PlaylistRecommendationResult => {
  return {
    playlistId: data.playlist_id,
    playlistName: data.playlist_name,
    trackCount: data.track_count,
    albumCount: data.album_count,
    currency: data.currency,
    totals: {
      cd: data.totals.cd,
      vinyl: data.totals.vinyl
    },
    albums: data.albums.map((album: Album) => ({
      id: album.id,
      name: album.name,
      artist: album.artist,
      url: album.url,
      coverUrl: album.cover_url,
      releaseYear: album.release_year,
      trackCount: album.track_count,
      tracks: album.tracks.map((t: Track) => t.name),
      trackDetails: album.tracks.map((t: Track) => ({
        id: t.id,
        name: t.name,
        artist: t.artist,
        durationMs: t.duration_ms,
        albumId: t.album_id
      })),
      prices: {
        cd: album.prices.cd ? { amount: album.prices.cd.amount, source: album.prices.cd.source } : null,
        vinyl: album.prices.vinyl ? { amount: album.prices.vinyl.amount, source: album.prices.vinyl.source } : null
      },
      buyLinks: (album.buy_links ?? []).map((link: BuyLink) => ({
        vendor: link.vendor,
        format: link.format,
        url: link.url
      }))
    }))
  };
};
